export const SET_SURVEYS = 'SET_SURVEYS';
export const SET_SURVEY_FORM = 'SET_SURVEY_FORM';
export const SET_SURVEY_LOGO = 'SET_SURVEY_LOGO';
